import ApiException from "@rmp/core/exceptions/apiException";

export default class RequestCancelledException extends ApiException {
	constructor() {
		super("RequestCancelledException");
	}
}
